import { Address, Person, UserRolePermission } from "@barthauer/custom/xmt-models";

export class UserRolePermissionViewModel extends UserRolePermission {
    Address?: Address;
    Person?: Person;
    UserRolePermission?: UserRolePermissionViewModel;
    ChildUserRolePermissions?: UserRolePermissionViewModel[];
    IdRefParentURPermission?: string;
    IdRefAddress?: string;
    isNew?: boolean;

    constructor(
        context: string,
        canView: boolean = false,
        canCreate: boolean = false,
        canDelete: boolean = false,
        canUpdate: boolean = false,
        permissions: UserRolePermissionViewModel[] = []
    ) {
        super({
        Context: context,
        CanView: canView,
        CanCreate: canCreate,
        CanDelete: canDelete,
        CanUpdate: canUpdate
        });
        this.ChildUserRolePermissions = permissions;
        this.isNew = true;
    }
}